import React from "react";
import CommonSeasonSettings from "../../season/components/SeasonSettings";

const SeasonSettings = () => {
	return <CommonSeasonSettings />;
};

export default SeasonSettings;
